import { useContext, Context } from 'react'

export const useContextSave = <T>(context: Context<T>) => {
  const contextValue = useContext(context)

  if (!contextValue)
    throw new Error(
      `useContextSave must be used within a ${
        context?.displayName || 'Context'
      }`,
    )

  return contextValue
}
